import React, { useContext } from 'react';
import { useRouter } from 'next/router';
import { RegistrationContext } from '@/modules/RegisterLayout/contexts/RegistrationContextProvider';
import StepperComponenet from '@/modules/common/components/StepperComponent/StepperComponenet';
import useIsMobile from '@/hooks/useIsMobile';
import { clampStep } from '@/modules/common/utils';
import CounsellingPreference from '../RegisterForm/CounsellingPreference/CounsellingPreference';
interface SideBarProps {
  formSteps: Array<{
    key: string;
    label: string;
    description: string;
    component: React.ComponentType<any>;
  }>;
}
const SideBar = ({
  formSteps
}: SideBarProps) => {
  const router = useRouter();
  const {
    courseId,
    step
  } = router.query;
  const {
    registrationDetails
  } = useContext(RegistrationContext);
  const isMobileScreen = useIsMobile();
  const highestReachedStep = clampStep(registrationDetails?.step, formSteps.length);
  const currentUrlStep = clampStep(step ?? registrationDetails?.step, highestReachedStep);

  // Block navigation past Counselling Preference if not yet selected
  const counsellingIndex = formSteps.findIndex(s => s.component === CounsellingPreference);
  const maxAllowedStep = counsellingIndex !== -1 && !registrationDetails?.counsellingPreference ? Math.min(highestReachedStep, counsellingIndex + 1) : highestReachedStep;
  return <div className="p-2 sm:!p-6 rounded-lg shadow-[0_8px_30px_rgb(0,0,0,0.12)] md:!shadow-[0_0_30px_rgb(0,0,0,0.12)] max-h-[60vh] overflow-y-scroll" data-sentry-component="SideBar" data-sentry-source-file="SideBar.tsx">
      <StepperComponenet orientation={isMobileScreen ? 'horizontal' : 'vertical'} steps={formSteps?.map(stepItem => ({
      description: stepItem.description
    }))} currentStep={currentUrlStep - 1} highestReachedStep={maxAllowedStep - 1} onClickStep={(index: number) => {
      if (index <= maxAllowedStep - 1) {
        router.push({
          pathname: '/register',
          query: {
            courseId,
            step: index + 1
          }
        });
      }
    }} textAlignment={isMobileScreen ? 'bottom' : 'right'} autoScroll data-sentry-element="StepperComponenet" data-sentry-source-file="SideBar.tsx" />
    </div>;
};
export default SideBar;